var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-field',{staticClass:"select-container"},[_c('md-select',{style:(_vm.selectContainerStyle),attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"multiple":_vm.multiple,"md-class":_vm.mdClass},on:{"md-selected":function($event){return _vm.handleInput($event)}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }